import discardSafeSendersOption from './actions/discardSafeSendersOption';
import saveSafeSendersOption from './actions/saveSafeSendersOption';
import SafeSendersFull from './components/SafeSendersFull';
import isSafeSendersOptionDirty from './utils/isSafeSendersOptionDirty';
import * as React from 'react';
var SafeSendersOption = {
    key: 'safeSenders',
    titleStringKey: 'optionTitle_safeSenders',
    searchTermsStringKey: 'optionTitle_safeSenders',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SafeSendersFull, null); },
        isDirty: isSafeSendersOptionDirty,
        onSave: saveSafeSendersOption,
        onDiscard: discardSafeSendersOption,
    },
};
export default SafeSendersOption;
//# sourceMappingURL=SafeSendersOption.js.map